import type { FoundationsVariants } from '@lemonade-hq/uniclient-theme';
import type { GridResponsiveColumns } from '../utils';
import type { UniclientBaseComponentProps, UniclientWizardComponentBase } from './types';

export interface ImageProps extends UniclientBaseComponentProps {
  readonly src: string;
  readonly alt: string;
  readonly columns?: GridResponsiveColumns;
  /**
   * @deprecated use the columns prop instead
   */
  readonly width?: number;
  /**
   * @deprecated use the columns prop instead
   */
  readonly height?: number;
  readonly borderRadius?: NonNullable<FoundationsVariants>['borderRadius'];
}

export type UniclientImage = ImageProps & UniclientWizardComponentBase<'image'>;

export function image(props: ImageProps): UniclientImage {
  return { ...props, type: 'image' };
}
